export default "{\n    \"resQCompany\": \"Get ResQ Ltd.\",\n    \"street\": \"18 King St East, Suite 1100\",\n    \"area\": \"Toronto, Ontario, M5C 1C4\"\n}\n"